import { z } from "zod";
import { AgencyTypeFieldsSchema, AgencyTypeSchema } from "../shared";

// Common/shared schemas used across multiple review types
export const V2ReviewClientSchema = z.object({
    id: z.number(),
    name: z.string(),
    email: z.string(),
    company_name: z.string(),
    company_website: z.string().nullable().optional(), 
    avatar_url: z.string().nullable().optional(), 
    is_repeat_client: z.boolean().optional(), 
});

export const V2ReviewExpertSchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string(),
    role: z.string().nullable().optional(),
    type: z.enum(["freelancer", "agency"]),
    agency_type: AgencyTypeSchema.optional(),
    agency_type_fields: AgencyTypeFieldsSchema.optional(),
    profile_picture: z.string().nullable().optional(),
});

export const V2ReviewProjectSchema = z.object({
    version: z.union([z.literal(1), z.literal(2)]).optional(),
    id: z.number(),
    name: z.string(),
});

export const V2ModeratorSchema = z.object({
    id: z.number(),
    name: z.string(),
    email: z.string(),
});

export const V2ModerationInfoSchema = z.object({
    moderated_by: V2ModeratorSchema.nullable(),
    moderated_at: z.string().nullable(), // ISO8601 datetime string
    moderation_notes: z.string().nullable(),
});

export const V2ReviewResponseSchema = z.object({
    id: z.number().optional(),
    response_text: z.string(),
    created_at: z.string(), // ISO8601 datetime string
    updated_at: z.string().optional(), // ISO8601 datetime string
});

export const ProjectValueRangeSchema = z.object({
    id: z.number(),
    min_value: z.number().nullable().transform((v) => v ?? 0),
    max_value: z.number().nullable().transform((v) => v ?? Infinity),
    label: z.string(),
    sort_order: z.number(),
});


